import React, { useState } from "react";

import { useTranslation } from "utils";

import { InputNumber, Modal } from "components";

type HectareModalProps = {
  existingHectares: number;
  open: boolean;
  onClose: () => void;
  onFinish: (hectares: number | null) => void;
};

export const HectareModal = ({ existingHectares, open, onClose, onFinish }: HectareModalProps) => {
  const { t } = useTranslation("cropExplorer");

  const [hectares, setHectares] = useState<number | null>(existingHectares);

  return (
    <Modal
      dataTestId="crop-explorer-tab-hectare-modal"
      title={t("hectareModal.title")}
      content={
        <>
          <p>{t("hectareModal.description")}</p>
          <InputNumber
            className="margin-top-100"
            label={t("cropExplorer:onboardingModal.fieldFormHectareInputPlaceholder")}
            rules={[{ required: true }]}
            suffix={t("cropExplorer:onboardingModal.fieldFormHectareInputSuffix")}
            value={hectares}
            onChange={(value) => setHectares(value)}
          />
        </>
      }
      okText={t("hectareModal.save")}
      cancelText={t("hectareModal.cancel")}
      onOk={() => onFinish(hectares)}
      showModal={open}
      onCancel={onClose}
      destroyOnHidden={true}
    />
  );
};
